import { render, staticRenderFns } from "./DomainCredentials.vue?vue&type=template&id=06846b39&"
import script from "./DomainCredentials.vue?vue&type=script&lang=js&"
export * from "./DomainCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports